import type { AbandonBankTransferInput } from '@repo/api-contracts';
import { useRef, useState } from 'react';
import { useInvalidateMyOrders } from '@/entities/order';
import { useInvalidateBankTransfer } from '@/entities/payment';
import { trpc } from '@/shared/api';
export const useAbandonBankTransfer = () => {
  const mutation = trpc.payments.abandonBankTransfer.useMutation();
  const orders = useInvalidateMyOrders();
  const invalidate = useInvalidateBankTransfer();
  const flight = useRef<Promise<void> | null>(null);
  const [isPending, setPending] = useState(false);
  const abandon = (input: AbandonBankTransferInput): Promise<void> => {
    if (flight.current) return flight.current;
    setPending(true);
    const pending = (async () => {
      await mutation.mutateAsync(input);
      await Promise.all([invalidate(input.orderId), orders.detail(input.orderId), orders.list()]);
    })().finally(() => {
      flight.current = null;
      setPending(false);
    });
    flight.current = pending;
    return pending;
  };
  return { abandon, isPending };
};
